@if (dirty === true) {
  <div class="unsaved-changes-bar">
    <div class="d-flex align-items-center justify-content-between">
      <strong>
        <i class="far fa-exclamation-triangle fa-fw unsaved-changes-bar__title-icon"></i>
        @if (dirty === true) {
          <span class="unsaved-changes-bar__title">
            {{ 'general.form.unsaved.changes' | portalTranslate }}
          </span>
        }
      </strong>
      <div class="unsaved-changes-bar__buttons">
        <button class="btn btn-link unsaved-changes-bar__button--reset" (click)="reset()" type="button">
          {{ 'button.reset' | portalTranslate }}
        </button>
        <portal-save-button
          class="unsaved-changes-bar__button--submit"
          [invalid]="invalid"
          [pristine]="!dirty"
          [state]="state"
          (save)="save()"
          >{{ saveButton }}</portal-save-button
        >
      </div>
    </div>
  </div>
}
